import { useCallback, useMemo, useState } from 'react';

import * as columnDefs from '../../../../../components/AGGrid/config/columns-def';
import {filterCriteria} from "../../../../../utils/filterCriteria";
import {getColumnType} from "../../../../../utils/columType";

export function useClearanceMemoGridUtils({
                                         datastageApi,
                                         filterForm,
                                              defaultFilterRange,
                                              updateClearanceMemoTitles,
                                              legalStatusOptions,
                                         isLegalUser,
                                         isLegalAdmin,
                                         handlers
                                     }) {
    const [sortedColId, setSortedColId] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc');

    const setSort = useCallback(
        async (colId, direction) => {
            setSortedColId(colId);
            setSortDirection(direction);
            handlers.setLoadingTrue();
            try {
                const data = await datastageApi.clearanceMemoTitles(
                    filterCriteria(filterForm, '', 'clearanceMemoTitles'),
                    defaultFilterRange,
                    [colId, direction.toUpperCase()]
                );
                updateClearanceMemoTitles({
                    titles: mapLegalStatus(data?.content, legalStatusOptions),
                    totalPages: data?.totalPages,
                    totalItems: data?.totalElements,
                    currentPage: data?.pageable?.pageNumber,
                    titleSort: [colId, direction.toUpperCase()]
                });
            } catch (error) {
                console.error('Error sorting clearance memo titles:', error);
            } finally {
                handlers.setLoadingFalse();
            }
        },
        [filterForm, defaultFilterRange, updateClearanceMemoTitles, handlers]
    );

    const baseColumns = columnDefs['titles'](
        ...handlers.columnHandlers
    )[getColumnType('titles', isLegalUser, isLegalAdmin)];

    const columns = useMemo(() => (
        baseColumns.map(col => ({
            ...col,
            headerComponentParams: {
                ...col.headerComponentParams,
                setSort,
                sortedColId,
                sortDirection,
            }
        }))
    ), [setSort, sortedColId, sortDirection, baseColumns]);

    return { setSort, columns };
}

const mapLegalStatus = (content, legalStatusOptions) =>
    content?.map((item) => ({
        ...item,
        legalStatusId:
            legalStatusOptions.find((lookup) => lookup.value === item?.legalStatusId)?.label ||
            null,
    }));